import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Checkbox } from 'antd';
import cn from 'classnames';

import { type LeadCardCheckboxItemData } from '@app/components/LeadCard/data';

import { useCheckboxSection } from './hooks/useCheckboxSection';

import type { FC } from 'react';

import './CheckboxSection.scss';

interface CheckboxSectionProps {
  title: string;
  items: LeadCardCheckboxItemData[];
  onChange(itemId: LeadCardCheckboxItemData['id'], checked: boolean): void;
  onSelectAll(): void;
  onClear(): void;
}

export const CheckboxSection: FC<CheckboxSectionProps> = ({
  title,
  items,
  onChange,
  onSelectAll,
  onClear,
}) => {
  const { isExpanded, toggleExpanded, itemChangeHandler } = useCheckboxSection({
    onChange,
  });

  return (
    <section className="CheckboxSection">
      <button
        type="button"
        className="CheckboxSection__toggle"
        aria-expanded={isExpanded}
        onClick={toggleExpanded}
      >
        <span className="CheckboxSection__divider">
          <span className="CheckboxSection__title">{title}</span>
        </span>
        <span
          className={cn('CheckboxSection__toggle-arrow', {
            'CheckboxSection__toggle-arrow--hidden': isExpanded,
          })}
        >
          <span className="CheckboxSection__toggle-arrow-inner">
            <DownOutlined className="CheckboxSection__arrow" />
          </span>
        </span>
      </button>

      <div
        className={cn('CheckboxSection__content', {
          'CheckboxSection__content--open': isExpanded,
        })}
      >
        <div className="CheckboxSection__content-inner">
          <div className="CheckboxSection__content-body">
            <div className="CheckboxSection__controls">
              <Button
                className="CheckboxSection__control"
                type="link"
                size="small"
                onClick={onSelectAll}
              >
                Все
              </Button>
              <Button
                className="CheckboxSection__control"
                type="link"
                size="small"
                onClick={onClear}
              >
                Очистить
              </Button>
            </div>
            <ul className="CheckboxSection__list">
              {items.map(({ id, checked, label }) => (
                <li className="CheckboxSection__row" key={id}>
                  <Checkbox checked={checked} onChange={itemChangeHandler(id)}>
                    <span className="CheckboxSection__row-label">{label}</span>
                  </Checkbox>
                </li>
              ))}
            </ul>
            <button
              type="button"
              className="CheckboxSection__collapse"
              aria-label={`Свернуть «${title}»`}
              onClick={toggleExpanded}
            >
              <UpOutlined className="CheckboxSection__arrow" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
